{
  "loading": "Nalaganje...",
  "loadingMore": "Nalaganje več vsebine..."
}
